import type { ContractOtherCostItemData } from 'gql/graphql';
import { SectionEnum } from 'gql/graphql';

import * as R from 'ramda';
import { useMemo } from 'react';

import { HeaderIds } from '../components/MenuCellRenderer';

export interface IUseContractOtherCostsGrouped {
    items?: any[];
}

export const useContractOtherCostsGrouped = (props: IUseContractOtherCostsGrouped) => {
    const { items } = props;

    const rows = useMemo(
        () =>
            items?.map((item: ContractOtherCostItemData) => {
                const mappedSeasons = item.seasonLimits?.reduce((a: any, sl) => {
                    a[`season${sl.seasonId}`] = sl.cost;

                    return a;
                }, {});

                return {
                    ...item,
                    ...mappedSeasons,
                };
            }),
        [items],
    );

    const rowsGrouped = useMemo(() => {
        const rowsBySection = R.groupBy(R.prop('section'), rows || []);
        const othersData = rowsBySection[SectionEnum.Others] ?? [];
        const customerLimitsData = rowsBySection[SectionEnum.CustomerLimits] ?? [];

        const othersDataAndHeader = othersData.length
            ? [{ id: HeaderIds.HEADER_OTHERS, name: 'Прочие затраты 9 главы' }, ...othersData]
            : [];

        const customerLimitsDataAndHeader = customerLimitsData.length
            ? [{ id: HeaderIds.HEADER_LIMITS, name: 'Лимиты заказчика' }, ...customerLimitsData]
            : [];

        return [...othersDataAndHeader, ...customerLimitsDataAndHeader];
    }, [rows]);

    const itemsCount = useMemo(() => items?.length || 0, [items?.length]);

    return { rowsGrouped, itemsCount };
};
